import { FILTER_BY, LOADED } from "./actionTypes";
import postsInitialState from "./initialState";

const filterReducer = (state = postsInitialState, { type, payload }) => {
    switch (type) {
        case LOADED:
            return { ...state, filteredPosts: payload };
        case FILTER_BY:
            return { ...state, filteredPosts: payload.posts, [payload.type]: payload.value };

        default:
            return state;
    }
}

export default filterReducer;